var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"system_body_color",staticStyle:{"min-height":"100vh"},attrs:{"height":_vm.height}},[_c('div',{attrs:{"id":"app"}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }